import type { ReactElement } from 'react';

import { Text } from '../../../components/texts';
import { Interface } from '../../../components/texts';
import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';

const Component = (props: Interface): ReactElement => {
	return <Text {...props} />;
};

export const AfterQuestionnaireText = styled(Component)(
	({ theme }: { theme: Theme }) => theme.questionnaireField.text.afterQuestionnaireMessage
);
